import * as qs from '@/ui/queryState';
import { Status } from '@/entities/todo';
import { IssuePriority, IssueType } from '@/entities/issue';
import { endsToday, startsLast30Days } from '@/ui/helpers/dateHelper';

export const useQueryFiltering = () => ({
  start: qs.date('start', startsLast30Days()),
  end: qs.date('end', endsToday()),
  entityItem: qs.numbers('entityItem', []),
  entityFolder: qs.strings('entityFolder', []),
  group: qs.numbers('group', []),
  //all 3 use same user field
  inspector: qs.numbers('user', []),
  creator: qs.numbers('user', []),
  assignee: qs.numbers('user', []),
  user: qs.numbers('user', []),
  category: qs.numbers('category', []),
  checklist: qs.numbers('checklist', []),
  questionTitle: qs.strings('questionTitle', []),
  response: qs.strings('response', []),
  section: qs.strings('section', []),
  inspection: qs.numbers('inspection', []),
  status: qs.numericEnums<Status>('type', Object.values(Status) as Status[], []),
  type: qs.stringEnums<IssueType>('type', Object.values(IssueType), []),
  priority: qs.numericEnums<IssuePriority>('priority', Object.values(IssuePriority) as IssuePriority[], []),
  sensor: qs.numbers('sensor', []),
  question: qs.strings('question', []),
});
